'use strict';

angular.module('app.deleteNetwork', [])	
	.controller('deleteNetworkCtrl', ['$scope', '$modal', '$modalInstance', 'deleteNetworkService',
		function ($scope, $modal, $modalInstance, deleteNetworkService) {
		    
		    $scope.confirmDelete = function () {
		    	deleteNetworkService.deleteNetwork($scope.network_id, true)
		    		.then(function(response) {
		    			$scope.modalInstance.close(function () {
			                $log.info('Close Modal now');
			            })

			            location.reload(true);
		    		}, function(response) {
		    			var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = response.message;
		    		})
		    }

		    $scope.closeModal = function() {
		        $modalInstance.close();
		    }
}])

